import { lazy, Suspense } from 'react'
import AuthGuard from '../components/guards/AuthGuard'
import { ConfluencePages, UserRole } from '../enums'
import AuthLayout from '../layouts/Auth'
import { UserManualProvider } from '../contexts/userManual'
import Redirect from '../pages/Redirect'
import GuestGuard from '../components/guards/GuestGuard'
import LoadingState from '../components/LoadingState'

const CompanyArchivedError = lazy(() => import('../pages/auth/CompanyArchivedError'))
const VerifyEmail = lazy(() => import('../pages/auth/VerifyEmail'))
const MFA = lazy(() => import('../pages/auth/MFA'))
const ResetMFA = lazy(() => import('../pages/auth/ResetMFA'))
const NewPassword = lazy(() => import('../pages/auth/NewPassword'))
const Page404 = lazy(() => import('../pages/error/Page404'))
const Page500 = lazy(() => import('../pages/error/Page500'))
const ResetPassword = lazy(() => import('../pages/auth/ResetPassword'))
const PrivacyPolicy = lazy(() => import('../pages/auth/PrivacyPolicy'))
const TermsOfService = lazy(() => import('../pages/auth/TermsOfService'))
const ChangePassword = lazy(() => import('../pages/auth/ChangePassword'))
const SignIn = lazy(() => import('../pages/auth/SignIn'))
const SignUp = lazy(() => import('../pages/auth/SignUp'))
const SignOut = lazy(() => import('../pages/auth/SignOut'))

export default [
  {
    path: '/auth/sign-in',
    element: (
      <GuestGuard>
        <UserManualProvider pageId={ConfluencePages.AUTH_SIGN_IN}>
          <AuthLayout>
            <Suspense fallback={<LoadingState align="center" />}>
              <SignIn />
            </Suspense>
          </AuthLayout>
        </UserManualProvider>
      </GuestGuard>
    )
  },
  {
    path: '/auth/sign-out',
    element: (
      <AuthLayout>
        <Suspense fallback={<LoadingState align="center" />}>
          <SignOut />
        </Suspense>
      </AuthLayout>
    )
  },
  {
    path: '/auth/change-password',
    element: (
      <AuthGuard
        roles={[
          UserRole.SUPERADMIN,
          UserRole.ADMIN,
          UserRole.USER,
          UserRole.MANUFACTURER,
          UserRole.GUEST,
          UserRole.INSTALLER
        ]}
      >
        <AuthLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <ChangePassword />
          </Suspense>
        </AuthLayout>
      </AuthGuard>
    )
  },
  {
    path: '/auth',
    element: (
      <GuestGuard>
        <Suspense fallback={<LoadingState align="center" />}>
          <AuthLayout />,
        </Suspense>
      </GuestGuard>
    ),
    children: [
      {
        path: '',
        element: <Redirect to="/auth/sign-in" />
      },
      {
        path: 'sign-up',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <SignUp />
          </Suspense>
        )
      },
      {
        path: 'sign-up/:token',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <SignUp />
          </Suspense>
        )
      },
      {
        path: 'reset-password',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <ResetPassword />
          </Suspense>
        )
      },
      {
        path: 'reset-password/:token',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <NewPassword />
          </Suspense>
        )
      },
      {
        path: 'change-password',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <ChangePassword />
          </Suspense>
        )
      },
      {
        path: 'mfa/user',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <MFA />
          </Suspense>
        )
      },
      {
        path: 'reset-mfa',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <ResetMFA />
          </Suspense>
        )
      },
      {
        path: 'verify-email',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <VerifyEmail />
          </Suspense>
        )
      },
      {
        path: 'verify-email/:token',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <VerifyEmail />
          </Suspense>
        )
      },
      {
        path: 'privacy-policy',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <PrivacyPolicy />
          </Suspense>
        )
      },
      {
        path: 'terms-of-service',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <TermsOfService />
          </Suspense>
        )
      },
      {
        path: '404',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <Page404 />
          </Suspense>
        )
      },
      {
        path: '500',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <Page500 />
          </Suspense>
        )
      },
      {
        path: 'company-archived',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <CompanyArchivedError />
          </Suspense>
        )
      },
      {
        path: '*',
        element: (
          <Suspense fallback={<LoadingState align="center" />}>
            <Page404 />
          </Suspense>
        )
      }
    ]
  }
]
